/** Même sélection datée pour les graphiques et les provisions. Une
 * reconstitution n'est jamais présentée comme une observation bancaire. */
export function selectMonthlyBankBalance<T>(
  period: string,
  observed: { cents: T | null; date: string | null } | null | undefined,
  calculated: { cents: T | null; date: string | null } | null | undefined,
): { cents: T | null; date: string | null; provenance: 'observé' | 'reconstitué' | 'absent' } {
  const observation =
    observed?.cents != null && observed.date?.slice(0, 7) === period ? observed : null;
  const reconstruction =
    calculated?.cents != null && calculated.date?.slice(0, 7) === period ? calculated : null;
  if (reconstruction && (!observation || reconstruction.date! > observation.date!))
    return { ...reconstruction, provenance: 'reconstitué' };
  return observation
    ? { ...observation, provenance: 'observé' }
    : { cents: null, date: null, provenance: 'absent' };
}
